<script>
export default {
    name: 'Day',
    props: {
        day: null,
        value: null,
        disabled: Boolean,
    },
    computed: {
        active() {
            return this.day && this.value ? this.day.isSame(this.value, 'day') : false
        },
    },
    methods: {
        input() {
            if (!this.disabled) this.$emit('input', this.day)
        },
    },
}
</script>

<template lang="pug">
    .day(v-html="$options.filters.toCalendarDay(day)" @click="input" :class="{'active': active, 'disabled': disabled}" role="button")
</template>
